import { apiFetch, apiRequest, ApiResult } from './api';

export interface Segment {
  id: string;
  name: string;
  description?: string;
  enableInFollowUp?: boolean;
  active: boolean;
  creationTime?: string;
  lastUpdateTime?: string;
}

export interface SegmentRQ {
  name: string;
  description?: string;
  enableInFollowUp?: boolean;
}

export const segmentApi = {
  async list(): Promise<Segment[]> {
    return apiFetch<Segment[]>('/Segment/GetAll', { auth: true });
  },

  async get(id: string): Promise<Segment> {
    return apiFetch<Segment>(`/Segment/Get/${encodeURIComponent(id)}`, { auth: true });
  },

  async create(data: SegmentRQ): Promise<ApiResult<Segment>> {
    return apiRequest<Segment>('/Segment/Create', {
      method: 'POST',
      auth: true,
      body: JSON.stringify(data),
    });
  },

  async update(id: string, data: SegmentRQ): Promise<ApiResult<Segment>> {
    return apiRequest<Segment>(`/Segment/Update/${encodeURIComponent(id)}`, {
      method: 'PUT',
      auth: true,
      body: JSON.stringify(data),
    });
  },

  async remove(id: string): Promise<void> {
    return apiFetch<void>(`/Segment/Delete/${encodeURIComponent(id)}`, {
      method: 'DELETE',
      auth: true,
    });
  },
};
